import _ from 'lodash';
import {MARKET} from "../config";

export const getPlaceholders = placeholders => {
    if (!_.includes(['sk', 'cz'], MARKET)) {
        if (_.has(placeholders, '{order.client.ico}')) {
            placeholders = { ...placeholders, '{order.client.company_id}': placeholders['{order.client.ico}'] };
            placeholders = _.omit(placeholders, ['{order.client.ico}']);
        }

        if (_.has(placeholders, '{order.client.dic}')) {
            placeholders = { ...placeholders, '{order.client.vat_id}': placeholders['{order.client.dic}'] };
            placeholders = _.omit(placeholders, ['{order.client.dic}']);
        }

        if (_.has(placeholders, '{order.client.ic_dph}')) {
            placeholders = _.omit(placeholders, ['{order.client.ic_dph}']);
        }
    }

    return placeholders;
};
